import firebase from "firebase";
import router from "@/router/index.js";

const state = {
  allContracts: []
};

const getters = {
  getContracts(state) {
    return state.allContracts;
  }
};

const mutations = {
  setContracts(state, payload) {
    state.allContracts = payload;
  }
};

const actions = {
  getAllContracts({ commit }) {
    const contracts = [];
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("contracts")
      .get()
      .then(snapshot => {
        snapshot.docs.forEach(doc => {
          var item = doc.data();
          contracts.push(item);
        });
      })
      .finally(() => {
        commit("setLoading", false);
        commit("setContracts", contracts);
      })
      .catch(err => {
        /*eslint-disable*/
        console.log(err);
        commit("setLoading", false);
      });
  },
  deleteContract({ commit, dispatch }, payload) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("contracts")
      .where("id", "==", payload)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          doc.ref.delete().then(() => {
            dispatch("getAllContracts");
            commit("setLoading", false);
          });
        });
      });
  },
  createNewContract({ commit, dispatch }, payload) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("contracts")
      .add(payload)
      .then(() => {
        commit("setLoading", false);
        dispatch("getAllContracts");
        router.push("/contracts");
      })
      .catch(err => {
        /*eslint-disable*/
        console.log(err);
        commit("setLoading", false);
      });
  },
  editContract({ commit, dispatch }, payload) {
    commit("setLoading", true);
    var id = null;
    firebase
      .firestore()
      .collection("contracts")
      .where("id", "==", payload.id)
      .get()
      .then(snapshot => {
        snapshot.docs.forEach(doc => {
          id = doc.id;
        });
      })
      .then(() => {
        firebase
          .firestore()
          .collection("contracts")
          .doc(id)
          .set(payload, { merge: true })
          .then(() => {
            commit("setLoading", false);
            dispatch("getAllContracts");
            router.push("/contracts");
          });
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
